<div class="filterSection" [ngClass]="{'opened': open, 'closed': !open}">
  <h6 (click)="toggleOpen.emit(openerProp); metaFilterTxtInput.nativeElement.focus()"><span class="selectedCount" [hidden]="!countOfSelected() || (countOfSelected() | async) < 1"> ({{ countOfSelected() | async }} selected)</span> {{ filterTitle }} </h6>
  <div class="innerFilterOptions" [style.max-height]="maxHeightOverwrite ? maxHeightOverwrite.toString() + 'px' : ''">
    <div [hidden]="!showMetaFilter">
      <input type="text" #metaFilterTxt [(ngModel)]="metaFilter" [matTooltip]="metaFilter.length ? 'Press Esc to clear' : 'Find the exact ' + filterTitle + ' by typing.'" placeholder="Type to narrow filters" value="" (keydown.esc)="metaFilter = ''" class="form-control form-control-sm">
    </div>
    <div *ngIf="displayMode === 3">
      <select name="fDropdown" (change)="emitFilterChange(true, $event.target.value)" class="form-control"
        id="batchNoDropDown">
        <option *ngIf="includeAllOption" [selected]="allOptionIsSelected" [value]="''">All</option>
        <option *ngFor="let x of optionData | filter : filterDisplayProperty : metaFilter" [value]="x[filterBindingProperty]">
          {{ x[filterDisplayProperty] }}</option>
      </select>
    </div>

    <div *ngIf="displayMode === 2 && optionData.length > 0">
      <div *ngIf="includeAllOption">
        <label [for]="filterTitle + 'X'" title="All" class="form-check-label">
          All {{ filterTitle }}
        </label>
        <input [id]="filterTitle + 'X'" type="checkbox" class="checkbox-input"
          [(ngModel)]="allOptionIsSelected" (ngModelChange)="emitFilterChange($event, 'All')">
      </div>
      <cdk-virtual-scroll-viewport class="scroller" itemSize="22">
        <div *cdkVirtualFor="let x of optionData | filter : filterDisplayProperty : metaFilter; let i = index; templateCacheSize: 1" style="padding-right: 2em;" [style.width.px]="parentWidth">
          <label [for]="filterTitle + i"
          class="form-check-label" [title]="x[filterDisplayProperty]">
            {{ x[filterDisplayProperty] }}
          </label>
          <input [id]="filterTitle + i" [name]="filterTitle + 'Btns'" type="checkbox" class="checkbox-input"
              [(ngModel)]="x.selected" (ngModelChange)="emitFilterChange($event, x)">
        </div>
      </cdk-virtual-scroll-viewport>
    </div>

    <div *ngIf="displayMode === 1">
        <div *ngFor="let x of optionData; let i = index">
          <label [for]="filterTitle + i">
            {{ x[filterDisplayProperty] }}
          </label>
          <input [id]="filterTitle + i" [name]="filterTitle + 'Btns'" class="checkbox-input ms-1" type="radio" [value]="x[filterBindingProperty]"
            [(ngModel)]="radioValStorage" (ngModelChange)="emitFilterChange($event, x)">
        </div>
      </div>

  </div>
</div>
